import React, { useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import { useIntl } from 'react-intl';
import { useClientRect } from '@whitelabel/helpers/hooks';
import { getCurrencySymbolOrName } from '@whitelabel/helpers/utils';
import { StyledCurrencyAmountInputBox, StyledAmountInput, StyledCurrencySymbol } from './styledCurrencyAmountInput';
import CurrencySelect from './CurrencySelect';

export interface ICurrencyAmountInputProps {
  id: string;
  invalid: boolean;
  [inputAttr: string]: any;
}

const CurrencyAmountInput = ({ id, invalid, ...props }: ICurrencyAmountInputProps): JSX.Element => {
  const { locale } = useIntl();
  const [field, { initialValue }, { setValue: setCurrency }] = useField(`${props.name}_currency`);
  const { value: currency } = field;
  const [currencySymbol, setCurrencySymbol] = useState(getCurrencySymbolOrName(locale, currency ?? initialValue));
  const currencySymbolRef = useRef<HTMLElement>(null);
  const currencySymbolRect = useClientRect(currencySymbolRef);
  const { bidi } = useIntl();

  useEffect(() => {
    setCurrencySymbol(getCurrencySymbolOrName(locale, currency));
  }, [currency, setCurrencySymbol, locale]);

  return (
    <StyledCurrencyAmountInputBox>
      <StyledAmountInput
        id={id}
        invalid={invalid}
        $currencySymbolWidth={currencySymbolRect?.width ?? 0}
        step="0.01"
        {...props}
        type="number"
      />
      <StyledCurrencySymbol ref={currencySymbolRef} $rtl={bidi}>
        {currencySymbol}
      </StyledCurrencySymbol>
      <CurrencySelect invalid={invalid} id={`${id}_currency`} setCurrency={setCurrency} field={field} />
    </StyledCurrencyAmountInputBox>
  );
};

export default CurrencyAmountInput;
